<script setup lang="ts">
import { computed } from "vue";

interface ImageWidgetProps {
  base64Src: string;
  mediaType: string;
  alt?: string;
}

const { base64Src, mediaType, alt = "" } = defineProps<ImageWidgetProps>();

const src = computed(() => {
  // ensure that media type really contains base64
  const mt = mediaType.endsWith(";base64") ? mediaType : `${mediaType};base64`;
  return `data:${mt}, ${base64Src}`;
});
</script>

<template>
  <img :src="src" :alt="alt" />
</template>
